// Utils
import { formatDateToUtc } from '@utils/helpers';

/**
 * Formats a number and an index to a string representation of a date.
 *
 * @function
 *
 * @param date - The number representing a date.
 * @param index - The index.
 * @param dateFormat - The format for the date.
 * @returns The formatted date string.
 */
export const formatTickToDate =
  (dateFormat = 'MMM yyyy') =>
  (date: number, index: number): string => {
    if (!date) return ''
    // Format the date month using 'MMM' format
    const [monthFormatted, yearFormatted] = formatDateToUtc(new Date(date), dateFormat).split(' ');

    // Determine if the index is divisible by 5
    const year = index % 5 === 0 && yearFormatted ? yearFormatted : '';

    // Concatenate the month and year formatted strings
    return `${monthFormatted}\n${year}`;
  };
